"use client";

import { api } from "@shared-server/api";

export const CacheWarmer = () => {
  const apiUtils = api.useUtils();

  void apiUtils.degradedFeature.all.prefetch();
  void apiUtils.utils.env.prefetch();
  void apiUtils.feature.allEnabledForMe.prefetch();

  return <></>;
};
